<template>
  <div id="app">
    <router-view />
    <notifications position="top center" width="400" classes="notify" />
  </div>
</template>

<script>
import axios from 'axios'
import router from './router/router'
import store from '../store'

if (process.env.NODE_ENV === 'development') {
  // 4. Девелоп сервер (бывший 126-й) - dev.webiomed.ai
  axios.defaults.baseURL = 'https://dev.webiomed.ai/'
  // axios.defaults.baseURL = 'https://next.webiomed.ru/'
  // 5. Denis
  // axios.defaults.baseURL = 'http://192.168.3.16/'
  // 5. Polina
  // axios.defaults.baseURL = 'http://10.99.1.14:8003/'
  // axios.defaults.baseURL = 'http://10.99.1.11'
} else {
  axios.defaults.baseURL = '/'
}

axios.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    // Do something with response error
    if (error.response.status === 401) {
      // console.log('handled')
      store.dispatch('deauthorize').then(router.push({ name: 'Login' }))
    }
    return Promise.reject(error)
  }
)

export default {}
</script>

<style lang="sass">
body
  min-height: 100vh
  background: url('assets/bg.jpg') no-repeat
  background-size: cover
  font-family: 'Roboto', Helvetica, Arial, sans-serif
  margin: 0
  padding: 0
a
  color: #0063aa
  transition: all ease-out

a:active
  text-decoration: none !important
  border: none !important

a:focus
  text-decoration: none !important
  border: none !important

b
  font-weight: 500

button
  outline: none
  cursor: pointer
  font-family: 'Roboto', Helvetica, Arial, sans-serif

input
  font-family: 'Roboto', Helvetica, Arial, sans-serif

textarea
  font-family: 'Roboto', Helvetica, Arial, sans-serif
  display: block
  width: 600px
  height: 100px
  padding: 6px 12px
  font-size: 15px
  color: #333333
  border: 1px solid #ccc
  border-radius: 4px
  transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s
  box-shadow: inset 0 1px 1px rgba(0,0,0,.075)

textarea:focus
  border-color: rgba(26, 163, 255, 0.8)
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset, 0 0 8px rgba(0, 153, 255, 0.6)

.globalCaptionStyles
  color: #000
  font-size: 32px
  font-weight: 300

.notify
  margin-top: 60px
  cursor: pointer
  font-size: 17px
  border-radius: 5px
  padding: 20px
  &.warn
    text-align: center
    color: #a94442
    background-color: #f2dede
    border: 1px solid #ebccd1
  &.sucsess
    text-align: center
    color: #1aa020
    background: #d3f8d3
    border: 1px solid #bdf5bd
</style>
